import { render, staticRenderFns } from "./branch_office.vue?vue&type=template&id=b5fb031c&scoped=true&"
import script from "./branch_office.vue?vue&type=script&lang=js&"
export * from "./branch_office.vue?vue&type=script&lang=js&"
import style0 from "./branch_office.vue?vue&type=style&index=0&lang=css&"
import style1 from "./branch_office.vue?vue&type=style&index=1&id=b5fb031c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fb031c",
  null
  
)

export default component.exports